const RESOURCESSUBTYPE_DELETE_DIALOG = 'RESOURCESSUBTYPE_DELETE_DIALOG';
const RESOURCESSUBTYPE_CREATE_DIALOG = 'RESOURCESSUBTYPE_CREATE_DIALOG';

export default {
    RESOURCESSUBTYPE_DELETE_DIALOG,
    RESOURCESSUBTYPE_CREATE_DIALOG
};
